
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/spotify",
      function () {
        return require("private-next-pages/destinations/spotify.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/spotify"])
      });
    }
  